//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "backbone", "messaging/messenger", "./kbAndLocaleSelectView"], function (
  Marionette,
  Backbone,
  Messenger,
  LocaleSelectView,
) {
  "use strict";

  var LocaleSelectController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "localeSelectModule";
    },
    show: function (kbs) {
      this.kbs = kbs;
      this._getLocalesForSelectedKb();
      var model = new Backbone.Model({
        kbs: this.kbs,
        locales: this.locales,
      });
      this.view = new LocaleSelectView.localeSelectView({ model: model });
      this.view.on(
        "kb:changed",
        function (kbId) {
          this.kbs.selectedId = kbId;
          this._getLocalesForSelectedKb();
          Messenger.vent.trigger("department:kb:changed", kbId);
        },
        this,
      );
      this.view.on(
        "locale:changed",
        function (localeId) {
          this.locales.selectedId = localeId;
          Messenger.vent.trigger("department:locale:changed", localeId);
        },
        this,
      );
      this.showRegion(this.view);
    },
    getSelectedKbId: function () {
      return this.kbs.selectedId;
    },
    getSelectedLocaleId: function () {
      return this.locales.selectedId;
    },
    _getLocalesForSelectedKb: function () {
      var selectedKbId = this.kbs.selectedId;
      if (!selectedKbId) {
        selectedKbId = Messenger.reqres.request("default:kbId");
      }
      var selectedKb = this.kbs.get(selectedKbId);
      if (!selectedKb) {
        console.error("Could not find KB " + selectedKbId);
        selectedKb = this.kbs.at(0);
      }
      var oldSelectedId;
      if (this.locales) {
        oldSelectedId = this.locales.selectedId;
      }
      if (!oldSelectedId) {
        oldSelectedId = Messenger.reqres.request("default:response:language");
      }
      this.locales = selectedKb.getLocales();
      // Set the Locale ID to the old ID until we can verify whether it is part of the new languages or not.
      // This will allow the Users select to work properly when it is first fetched.
      this.locales.selectedId = oldSelectedId;
      this.locales.onSynced(function () {
        var locale = this.locales.get(oldSelectedId);
        if (!locale && this.locales.length > 0) {
          locale = this.locales.at(0);
        }
        if (!locale) {
          this.locales.selectedId = Messenger.reqres.request("default:response:language");
        } else {
          this.locales.selectedId = locale.id;
        }
        if (this.locales.selectedId !== oldSelectedId) {
          Messenger.vent.trigger("department:locale:changed", this.locales.selectedId);
        }
        this.view.model.set("locales", this.locales);
        this.view.render();
      }, this);
    },
  });

  return LocaleSelectController;
});
